<template>
  <div>
    <hr>
    <div :class='$style.buttonContainer'>
      <button
        class='button'
        v-if='isBlockedRecipientsAdmin'
        @click='isAddModalOpen = true'
      >
        Add Blocked Recipient
      </button>
    </div>

    <ErrorNotification
      v-if='errors.length'
      :messages='errors'
      @clear='errors = []'
    />

    <BlockedRecipientsList
      v-if='blockedRecipients.length'
      :list='blockedRecipients'
      @rowClicked='onRowClicked'
    />

    <BlockedRecipientDetails
      :isOpen='isDetailsOpen'
      :recipient='selected'
      :isAdmin='isBlockedRecipientsAdmin'
      :errors='detailsErrors'
      @delete='onDeleteRecipient'
      @close='closeDetails'
      @clearErrors='detailsErrors = []'
    />

    <AddBlockedRecipient
      v-if='isAddModalOpen'
      :isOpen='isAddModalOpen'
      :errors='addErrors'
      @submit='onAddBlockedRecipient'
      @close='isAddModalOpen = false'
      @clearErrors='addErrors = []'
    />
  </div>
</template>

<script>
import useUserHasPermission from '@/composables/useUserHasPermission';
import {
  getBlockedRecipients,
  createBlockedRecipient,
  deleteBlockedRecipient
} from '@/request';
import BlockedRecipientsList from '@/components/BlockedRecipientsList.vue';
import BlockedRecipientDetails from '@/components/BlockedRecipientDetails.vue';
import AddBlockedRecipient from '@/components/AddBlockedRecipient.vue';
import ErrorNotification from '@/components/ErrorNotification.vue';

const BLOCK_RECIPIENTS_ADMIN_PERMISSION = 'blockRecipientAdmin';

export default {
  name: 'BlockedRecipients',

  components: {
    BlockedRecipientsList,
    BlockedRecipientDetails,
    AddBlockedRecipient,
    ErrorNotification
  },

  setup() {
    const { hasPermission } = useUserHasPermission(BLOCK_RECIPIENTS_ADMIN_PERMISSION);
    return {
      isBlockedRecipientsAdmin: hasPermission
    };
  },

  data() {
    return {
      loading: true,
      isAddModalOpen: false,
      isDetailsOpen: false,
      selected: {},
      blockedRecipients: [],
      errors: [],
      addErrors: [],
      detailsErrors: []
    }
  },

  async mounted() {
    this.loading = true;
    await this.fetchBlockedRecipients();
    this.loading = false;
  },

  methods: {
    async fetchBlockedRecipients() {
      try {
        this.blockedRecipients = await getBlockedRecipients();
      } catch (error) {
        this.errors = [error.message];
      }
    },

    async onAddBlockedRecipient({ domain, blockType, comment }) {
      try {
        await createBlockedRecipient(domain, blockType, comment);
        this.fetchBlockedRecipients();
        this.isAddModalOpen = false;
      } catch (error) {
        this.addErrors = [error.message];
      }
    },

    async onDeleteRecipient(domain) {
      try {
        await deleteBlockedRecipient(domain);
        this.fetchBlockedRecipients();
        this.isDetailsOpen = false;
      } catch (error) {
        this.detailsErrors = [error.message];
      }
    },

    onRowClicked(recipient) {
      this.isDetailsOpen = true;
      this.selected = recipient;
    },

    closeDetails() {
      this.isDetailsOpen = false;
      this.selected = {};
      this.detailsErrors = [];
    }
  }
}
</script>

<style lang='scss' module>
.buttonContainer {
  text-align: center;

  button {
    margin: 10px;
  }
}

</style>